// extracted by mini-css-extract-plugin
export default {"MainLogo":"MainLogo_MainLogo__LkXPL"};